import { render, staticRenderFns } from "./jsaActionDetail.vue?vue&type=template&id=b28fdd1c"
import script from "./jsaActionDetail.vue?vue&type=script&lang=js"
export * from "./jsaActionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b28fdd1c')) {
      api.createRecord('b28fdd1c', component.options)
    } else {
      api.reload('b28fdd1c', component.options)
    }
    module.hot.accept("./jsaActionDetail.vue?vue&type=template&id=b28fdd1c", function () {
      api.rerender('b28fdd1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/jsa/action/jsaActionDetail.vue"
export default component.exports